import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { FetchStatuses } from 'builder/modules/constants'
import { useI18n } from 'builder/hooks/useI18n'
import { ButtonTheme } from 'builder/components/Button'
import {
  Title,
  SubTitle,
  ErrorButtonContainer,
  Container,
  ErrorImage,
  CloseIconWrapper,
  CloseIcon,
  Button,
  ErrorContentContainer,
  ErrorHeaderWrapper,
} from '../styles'
import { LOCALIZATION_KEY } from '../constants'
import errorImage from '../assets/draft-search.png'
import { useCreateResumeWithLinkedin } from '../useCreateResumeWithLinkedin'

export const LinkedInError = () => {
  const { i18n } = useI18n()
  const { fetchLinkedInProfileStatus, handleTryAgain, handleReturnStart, handleClose } =
    useCreateResumeWithLinkedin()

  useEffect(() => {
    trackInternalEvent('see_linkedin_profile_error_screen', {
      label: 'li_prefill',
    })
  }, [])

  return (
    <Container>
      <CloseIconWrapper onClick={handleClose}>
        <CloseIcon />
      </CloseIconWrapper>
      <ErrorContentContainer>
        <ErrorImage src={errorImage} alt="Create Resume With LinkedIn Error" />
        <ErrorHeaderWrapper>
          <Title>{i18n.t(`${LOCALIZATION_KEY}.error_modal.title`)}</Title>
          <SubTitle>{i18n.t(`${LOCALIZATION_KEY}.error_modal.description`)}</SubTitle>
        </ErrorHeaderWrapper>
      </ErrorContentContainer>
      <ErrorButtonContainer>
        <Button theme={ButtonTheme.ghost} onClick={handleReturnStart}>
          {i18n.t(`${LOCALIZATION_KEY}.error_modal.return_start_button_text`)}
        </Button>
        <Button
          onClick={handleTryAgain}
          isLoading={fetchLinkedInProfileStatus === FetchStatuses.loading}
        >
          {i18n.t(`${LOCALIZATION_KEY}.error_modal.try_again_button_text`)}
        </Button>
      </ErrorButtonContainer>
    </Container>
  )
}
